<template lang="html">
  <div class="actions-panel">

    <span v-if="hint" class="hint">
      {{ hint }}
    </span>

    <div class="buttons-group">
      <button
        :disabled="xlsExporting"
        @click="exportAction"
        class="vcv-button gray iconed xls"
        v-tooltip.top-center="$tr('invites.exportToExcel')"
      >
        <i class="fa fa-file-excel-o"/>
        <span>{{ $tr('invites.exportToExcel') }}</span>
      </button>

      <button :disabled="!isElementsSelected"
        @click="sendMessageAction"
        class="vcv-button gray iconed mail"
        v-tooltip.top-center="$tr('common.iconTooltips.mailSelectedCandidates')"
      >
        <i class="icon icon-envelope"/>
        <span>{{ $tr('responses.actions.sendMail') }}</span>
      </button>

      <button :disabled="!isElementsSelected"
        @click="linkShareAction"
        class="vcv-button gray"
        v-tooltip.top-center="$tr('common.iconTooltips.sendLinkToSelectedCandidates')"
      >
        <i class="icon icon-send"/>
        {{ $tr('responses.actions.share') }}
      </button>
    </div>
  </div>

</template>

<script>
  import Pluralize from '@/mixins/pluralize'

  export default {
    name: 'action-panel',

    mixins: [
      Pluralize
    ],

    props: {
      listLength: {
        type: Number,
        default: 0
      },
      isElementsSelected: {
        type: Boolean,
        default: false
      },
      exportAction: {
        type: Function,
        required: true
      },
      sendMessageAction: {
        type: Function,
        required: true
      },
      linkShareAction: {
        type: Function,
        required: true
      }
    },

    computed: {
      xlsExporting () {
        return this.$store.state.search.xlsExportingResponses
      },

      hint () {
        const count = this.listLength

        if (!count) {
          return ''
        }

        const start = this.$tc('common.selectedResponses', count)
        const pluralized = this.pluralize(this.$tr('responses.candidate'), count)

        return `${start} ${count} ${pluralized}`
      }
    },

    beforeMount () {
      // Fetch company users to share link email list
      this.$store.dispatch('users/fetchUsersDropdown')
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/queries.scss';

  .actions-panel {
    display: flex;
    align-self: center;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;

    @include tablet {
      .hint {
        display: none;
      }
    }

    @include mobile {
      .hint {
        display: none;
      }
    }
  }
</style>
